import { useEffect } from 'react';
import { Check } from 'lucide-react';

interface SuccessToastProps {
  message: string;
  onDismiss: () => void;
  /** Auto-dismiss delay in ms. Longer messages should get more time to read. */
  durationMs?: number;
}

/**
 * Bottom-anchored confirmation toast. Sits above the bottom tab bar on mobile
 * and auto-dismisses after `durationMs`.
 */
export function SuccessToast({ message, onDismiss, durationMs = 2500 }: SuccessToastProps) {
  useEffect(() => {
    const t = setTimeout(onDismiss, durationMs);
    return () => clearTimeout(t);
  }, [onDismiss, durationMs]);

  return (
    <div
      role="status"
      className="fixed bottom-20 left-4 right-4 md:left-1/2 md:right-auto md:-translate-x-1/2 md:max-w-md z-50
                 flex items-start gap-2 px-4 py-3 rounded-xl bg-midnight text-white shadow-lg
                 animate-in slide-in-from-bottom-4 fade-in duration-200"
    >
      <Check size={16} className="text-emerald-400 shrink-0 mt-0.5" />
      <span className="text-sm font-medium leading-snug">{message}</span>
    </div>
  );
}
